module.exports = __webpack_public_path__ + "img/course-cover03.975f116b.jpg";